import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Font, Image } from '@react-pdf/renderer';
import React from 'react';
// @ts-ignore
import font from "../../../../assest/font/dana-fanum-regular.woff";
import { IPdfDownloaderProps } from './PdfDownloader.models';
import Table from './common/Table';
import QuickChart from 'quickchart-js';
import BarandeSaz_Logo from '../../../../assest/images/brand/Avatar.png';

Font.register({
    family: "Dana-Fanum",
    format: "truetype",
    src: font,
});
const primaryFontSize = 9
const styles = StyleSheet.create({
    page: {
        fontSize: primaryFontSize,
        flexDirection: "column",
        textAlign: 'right',
        padding: '20px',
        fontFamily: "Dana-Fanum",
    },
    sectionHeader: {
        fontWeight: 'bold',
        margin: '5px 0',
        fontSize: primaryFontSize + 3,
        flex: 1
    },
    rowWarp: {
        display: 'flex',
        flexDirection: 'row-reverse',
        flexWrap: 'wrap',
        textAlign: 'right'
    },
    centerAlign: {
        display: 'flex',
        justifyContent: 'center',
    },
    logo: {
        maxWidth: '80px',
        minWidth: '80px'
    }
});

const Row = ({ children, style }: any) => (
    <View
        style={[{ display: 'flex', flexDirection: 'row', width: '100%' }, style]}>
        {children}
    </View>
)

const RowItem = ({ title, value }: any) => (
    <>
        <Text style={{ marginLeft: 1 }}> {title} </Text>
        <Text style={{ marginLeft: 10 }}> {value}</Text>
    </>
)

const SectionHeader = ({ children, secondary = false, style = {} }: any) => (
    <Text
        style={[
            styles.sectionHeader,
        ]}>
        {children}
    </Text>
)

export default class PdfDownloader extends React.PureComponent<IPdfDownloaderProps, { chartImage?: string, performancePercentagechartImage?: string }> {
    constructor(props: any) {
        super(props);
        this.state = { chartImage: undefined };
    }

    componentDidMount(): void {
        this.setChartImag()
        this.setPerformancePercentageChartImag()
    }

    setChartImag = () => {
        let categories = this.props.chartData ? this.props.chartData[0].data.map(({ title }) => title) : []

        var series = this.props.chartData ?
            this.props.chartData.map((item) => {
                return {
                    data: item.data.map(({ value }) => value),
                    label: item.title,
                    fill: false,
                    fontSize: 9,
                    borderWidth: 1.5,
                    pointStyle: '',
                    borderCapStyle: false,
                    lineTension: 0.2,
                    backgroundColor: 'transparent'
                }
            }) : []

        const chart = new QuickChart();
        chart.setConfig({
            type: 'line',
            data: { labels: categories, datasets: series },
            options: {
                legend: {
                    position: 'bottom',
                    color: '#000',
                    labels: {
                        color: '#000',
                        fontSize: 8,
                        fontColor: 'black',
                        fontFamily: 'Serif',
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                suggestedMax: 10,
                                beginAtZero: true,
                                fontSize: 8,
                                fontColor: 'black',
                                fontFamily: 'Mono',
                            },
                        },
                    ],
                    xAxes: [
                        {
                            ticks: {
                                color: '#000',
                                fontSize: 8,
                                fontColor: 'black',
                                fontFamily: 'Serif',
                            },
                        },
                    ],
                },
            }
        });
        chart.setHeight(150).setBackgroundColor('transparent');
        let quickchart = chart.getUrl()
        this.setState({ chartImage: quickchart }, () => this.forceUpdate())
    }

    setPerformancePercentageChartImag = () => {
        let { examInformation } = this.props
        let examCorrectAnswerPercent = (examInformation?.examCorrectAnswer as number) / (examInformation?.totalQuestion as number) * 100
        let examUnAnswerPercent = (examInformation?.examUnAnswer as number) / (examInformation?.totalQuestion as number) * 100
        let examWrongAnswerPercent = (examInformation?.examWrongAnswer as number) / (examInformation?.totalQuestion as number) * 100

        const chart = new QuickChart();
        chart.setConfig({
            type: 'doughnut',
            data: {
                datasets: [
                    {
                        data: [examCorrectAnswerPercent.toFixed(2), examWrongAnswerPercent.toFixed(2), examUnAnswerPercent.toFixed(2)],
                        backgroundColor: [
                            '#90ed7d',
                            '#cfd8dc',
                            '#f53c56',
                        ],
                        fontSize: 5,
                    },
                ],
                labels: ['پاسخ درست', 'پاسخ نادرست', 'پاسخ نزده'],
            },
            options: {
                legend: {
                    position: 'bottom',
                    color: '#000',
                    border: 'none',
                    labels: {
                        color: '#000',
                        fontSize: 8,
                        fontColor: 'black',
                        fontFamily: 'Serif',
                    }
                },
                doughnutlabel: {
                    labels: { fontSize: 6, color: '#000' }
                },
                plugins: {
                    datalabels: {
                        formatter: (value: number) => {
                            return value + '%';
                        },
                    },
                },
            }
        });
        chart.setHeight(120).setBackgroundColor('transparent');
        let quickchart = chart.getUrl()
        this.setState({ performancePercentagechartImage: quickchart }, () => this.forceUpdate())
    }

    render(): React.ReactNode {
        let { examInformation, chartData } = this.props
        const ReportDocument = () => (
            <Document>
                <Page size="A4" style={styles.page}>
                    <Row style={{
                        ...styles.centerAlign,
                        marginBottom: '20px',
                    }}>
                        <Image style={{ ...styles.logo }} src={BarandeSaz_Logo} />
                    </Row>
                    <Row>
                        <SectionHeader>اطلاعات آزمون</SectionHeader>
                    </Row>
                    <Row
                        style={{
                            ...styles.rowWarp,
                            fontWeight: 'bold',
                        }}>
                        <RowItem value={examInformation?.id} title="شماره آزمون:" />
                        <RowItem value={examInformation?.title} title="عنوان:" />
                        <RowItem value={examInformation?.examDate ?? '-'} title="تاریخ برگزاری:" />
                        <RowItem value={examInformation?.fieldTitle ?? '-'} title="رشته:" />
                        <RowItem value={examInformation?.baseTitles ?? '-'} title="پایه:" />
                        <RowItem value={examInformation?.participantsCount} title="شرکت کنندگان:" />
                        <RowItem value={examInformation?.studentExamRank} title="رتبه ی کل آزمون:" />
                    </Row>
                    <Row style={{
                        ...styles.rowWarp,
                        marginTop: '20px'
                    }}>
                        <SectionHeader>جدول آمار دروس</SectionHeader>
                    </Row>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell>ردیف</Table.HeaderCell>
                            <Table.HeaderCell>نام درس</Table.HeaderCell>
                            <Table.HeaderCell>تعداد</Table.HeaderCell>
                            <Table.HeaderCell>درست</Table.HeaderCell>
                            <Table.HeaderCell>غلط</Table.HeaderCell>
                            <Table.HeaderCell>نزده</Table.HeaderCell>
                            <Table.HeaderCell>نمره</Table.HeaderCell>
                            <Table.HeaderCell>تراز</Table.HeaderCell>
                            <Table.HeaderCell>بالاترین نمره</Table.HeaderCell>
                            <Table.HeaderCell>بالاترین تراز</Table.HeaderCell>
                            <Table.HeaderCell>رتبه آزمون</Table.HeaderCell>
                            <Table.HeaderCell>میانگین نمرات</Table.HeaderCell>
                        </Table.Header>
                        <Table.Body>
                            {examInformation?.courseStatistics.map((item, index) => (
                                <Table.Row key={item.courseId}>
                                    <Table.Cell>{index + 1}*</Table.Cell>
                                    <Table.Cell>{item.courseTitle}</Table.Cell>
                                    <Table.Cell>{item.count}</Table.Cell>
                                    <Table.Cell>{item.correctCount}</Table.Cell>
                                    <Table.Cell>{item.wrongCount}</Table.Cell>
                                    <Table.Cell>{item.unAnswered}</Table.Cell>
                                    <Table.Cell>{item.percent.toFixed(2)}</Table.Cell>
                                    <Table.Cell>{item.level}</Table.Cell>
                                    <Table.Cell>{item.topPercent.toFixed(2)}</Table.Cell>
                                    <Table.Cell>{chartData?.filter(dataitem => dataitem.key == "TOP")[0]?.data.filter(dataitem => dataitem.title == item.courseTitle)[0].value}</Table.Cell>
                                    <Table.Cell>{item.rank}</Table.Cell>
                                    <Table.Cell>{item.avragePrecent.toFixed(2)}</Table.Cell>
                                </Table.Row>
                            ))}
                            <Table.Row>
                                <Table.Cell> </Table.Cell>
                                <Table.Cell>جمع کل</Table.Cell>
                                <Table.Cell>{examInformation?.totalQuestion}</Table.Cell>
                                <Table.Cell>{examInformation?.examCorrectAnswer}</Table.Cell>
                                <Table.Cell>{examInformation?.examWrongAnswer}</Table.Cell>
                                <Table.Cell>{examInformation?.examUnAnswer}</Table.Cell>
                                <Table.Cell>{examInformation?.examPercent}</Table.Cell>
                                <Table.Cell>-</Table.Cell>
                                <Table.Cell>-</Table.Cell>
                                <Table.Cell>-</Table.Cell>
                                <Table.Cell>-</Table.Cell>
                                <Table.Cell>-</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <Row style={{
                        marginTop: '20px'
                    }}>
                        <SectionHeader>نمودار تراز</SectionHeader>
                    </Row>
                    <Row>
                        {
                            this.state.chartImage != undefined &&
                            <Image src={this.state.chartImage} style={{ fontFamily: 'Dana-Fanum' }} />
                        }
                    </Row>
                    <Row style={{
                        marginTop: '20px'
                    }}>
                        <SectionHeader>نمودار عملکرد</SectionHeader>
                    </Row>
                    <Row>
                        {
                            this.state.performancePercentagechartImage != undefined &&
                            <Image src={this.state.performancePercentagechartImage} style={{ fontFamily: 'Dana-Fanum' }} />
                        }
                    </Row>
                </Page>
            </Document >
        )

        return (<>
            <PDFDownloadLink document={<ReportDocument />} fileName="exam-report.pdf">
                {({ blob, url, loading, error }) => (<div className="sticky-footer col-12 pt-2" id="download-pdf">
                    <button disabled={this.state.chartImage == undefined} className="btn btn-primary tk-full-width">دانلود کارنامه (فایل PDF)</button>
                </div>)}
            </PDFDownloadLink>
        </>);
    }
}